export { default } from './RecentlyViewed';
